export default "__VITE_ASSET__f4d16ead__"